import { Route } from '@untitledui/icons'

import ToolbarButton from '@components/toolbar/ToolbarButton'
import { useDayScans } from '@hooks/useDayScans'
import useTypedTranslation from '@hooks/useTypedTranslation'

function ScanModeToggle() {
  const { t } = useTypedTranslation()
  const { dayScan, newestScan, showScan } = useDayScans()

  return (
    <ToolbarButton
      label={t(dayScan ? 'storeMap.scanMode.exit' : 'storeMap.scanMode.enter')}
      isActive={!!dayScan}
      isDisabled={!dayScan && !newestScan}
      onClick={() => showScan(dayScan ? null : newestScan!.id)}
    >
      <Route />
    </ToolbarButton>
  )
}

export default ScanModeToggle
